import React from 'react';
import './styles.css';
import './BibleList.css';
import { editionForBook } from '../utils/bibleEditions';

function BibleList({ title, type, books }) {
  const availableBooks = books.filter(([route]) => editionForBook(type, route));
  if (!availableBooks.length) return null;
  return (
    <div className="section bible-list">
      <h1><span className="bible-list__gold">{title}</span></h1>
      <div>
        {availableBooks.map(([route, displayName]) => (
          <div className="li" key={route}>
            <a href={`/bible/${route}?type=${editionForBook(type, route)}`}>
              <span className="bible-list__gold">{type === 'en' ? route : displayName}</span>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BibleList;
